// src/pages/Community/components/DetailSidePanel.js
import "./css/DetailSidePanel.css";

export default function DetailSidePanel({
    open,
    title,
    children,
    onClose,
    onMaximize,
}) {
    if (!open) return null;

    return (
        <aside className="entity-panel" role="dialog" aria-modal="true">
            <div className="entity-panel__top">
                <strong className="entity-panel__title">
                    {title}
                </strong>

                <div className="entity-panel__actions">
                    {onMaximize && (
                        <button
                            onClick={onMaximize}
                            title="Open full view"
                            className="icon-btn"
                        >
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M15 3h6v6" />
                                <path d="M9 21H3v-6" />
                                <path d="M21 3l-7 7" />
                                <path d="M3 21l7-7" />
                            </svg>
                        </button>

                    )}
                    <button
                        onClick={onClose}
                        title="Close"
                        className="icon-btn"
                    >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>

                </div>
            </div>

            <div className="entity-panel__body">
                {children}
            </div>
        </aside>
    );
}
